import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export interface accountCopyFetchInterface {
  sourceAccountId: string;
  targetAccountId: string;
}

const queryKeyBase = "ddc-pages-media-library-copy";

export function useMediaLibraryCopyGetStatus(
  token?: string,
  refetchInterval?: number
) {
  return useQuery({
    refetchInterval,
    queryKey: [queryKeyBase + "-token", token],
    queryFn: () => fetchMediaLibraryCopyGetStatus(token?.trim() || ""),
    enabled: !!token && token.trim().length > 0
  });
}
export function useMediaLibraryCopyPerformCopy() {
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    mutationFn: (config: accountCopyFetchInterface) => {
      return performMediaLibraryCopyPerformCopy(config);
    }
  });
}
const performMediaLibraryCopyPerformCopy = (
  config: accountCopyFetchInterface
): Promise<string> => {
  if (!config.sourceAccountId || !config.targetAccountId) {
    return Promise.reject("sourceAccountId and targetAccountId are required");
  }
  if (config.sourceAccountId === config.targetAccountId) {
    return Promise.reject(
      "sourceAccountId and targetAccountId cannot be the same"
    );
  }
  return fetch(
    `/landing/nxlambda/mediaLibraryCopy/${config.sourceAccountId}/${config.targetAccountId}`
  ).then(async res => {
    if (res.ok) {
      return (await res.json()).token;
    } else {
      throw new Error(res.statusText);
    }
  });
};

export interface MediaLibraryCopyStatus {
  logLines: string[];
  status: string;
}

const fetchMediaLibraryCopyGetStatus = (
  token: string
): Promise<MediaLibraryCopyStatus> => {
  const tokenUrl = `/landing/nxlambda/mediaLibraryCopyStatus/${token}`;
  return fetch(tokenUrl).then(res => {
    if (res.ok) {
      return res.json() as Promise<MediaLibraryCopyStatus>;
    } else {
      throw new Error(res.statusText);
    }
  });
};
